module.exports = __webpack_public_path__ + "media/images/img_search05-0cfd64d97f81baa2a05c5bbb7c95a73c.png";